import React from "react";

/**
 * Header action button.
 * - primary: solid primary CTA used by all module pages
 * - dashboard: brand outlined style used only on Dashboard
 */
const ModuleHeaderAction = ({
  children,
  variant = "primary",
  className = "",
  type = "button",
  as: Tag = "button",
  ...props
}) => {
  const classes = [
    "module-header-action",
    `module-header-action--${variant}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Tag type={Tag === "button" ? type : undefined} className={classes} {...props}>
      {children}
    </Tag>
  );
};

export default ModuleHeaderAction;
